function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createElement } from 'react';
import PropTypes from 'prop-types';
import { createComponentFactory, THEME_CHANNEL } from 'fela-bindings';

import withTheme from './withTheme';

export default createComponentFactory(createElement, withTheme, _defineProperty({
  renderer: PropTypes.object
}, THEME_CHANNEL, PropTypes.object), true);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/react-fela/es/createComponentWithProxy.js
// module id = 1192
// module chunks = 0